import React, {PropsWithChildren} from 'react';

const style = {
	label: `w-full h-24   font-whirlwindSecondary text-7xl recommended:text-8xl text-center text-whirlwindPrimaryLight`,
};

export const Header = ({children}: PropsWithChildren) => {
	return <span className={style.label}>{children}</span>;
};
